import React from 'react';
import { Link } from 'gatsby';

import * as styles from './Card.module.scss';

type CardProps = {
  title: string;
  imageUrl: string;
  linkUrl?: string;
};
const Card = ({ title, imageUrl, linkUrl }: CardProps): React.ReactElement => {
  return (
    <div className={styles.container}>
      <Link to={linkUrl!} className={styles.cardLink}>
        <div className={styles.imageContainer}>
          <img src={imageUrl} alt=""></img>
        </div>
        <div className={styles.titleContainer}>
          <span className={styles.title}>{title}</span>
        </div>
      </Link>
    </div>
  );
};

export default Card;
